import React from "react"

const FetcherContext = React.createContext(null)
const FetcherProvider = ({children}) => {
  const initialValues = {
    api: process.env.API_URL,
    options: {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    },
  }
  return (
    <FetcherContext.Provider value={initialValues}>
      {children}
    </FetcherContext.Provider>
  )
}
const FetcherConsumer = FetcherContext.Consumer

export default FetcherContext
export {FetcherConsumer, FetcherProvider}
